import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import * as yup from "yup";

import * as Params from "../../models/clientModels/interfaces/apiParams";
import * as boardApi from "../../api/boardApi/boardApi";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import {KPBoard, initializeBoard} from "../../models/serverModels/board/KPBoard";
import BoardForm from "./BoardForm";

const CreateBoard = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<KPBoard>,
    Params.Create<KPBoard>
  >({
    api: boardApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Board");
        queryClient.invalidateQueries("BoardList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<KPBoard>({
    defaultValues: initializeBoard(),
  });
  const onSubmit: SubmitHandler<KPBoard> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeBoard(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="게시판 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <BoardForm />
          <ConfirmButtonGroup link="/Board" cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateBoard;
